var exports = {
  "F": "CtaBanner__3YsEXo",
};

module.exports = exports;
